import React from "react";

function SvgZip(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 179.695 194.275"
    >
      <g id="compressed" transform="translate(-59.7 -2)" opacity="0.85">
        <path
          id="Path_16520"
          data-name="Path 16520"
          d="M179.39,2H73.019C65.65,2,59.7,6.972,59.7,13.129V185.147c0,6.157,5.95,11.129,13.319,11.129H226.076c7.369,0,13.319-4.972,13.319-11.129V52.137Z"
          transform="translate(0)"
          fill={"#5ac8ae"+blur}
        />
        <path
          id="Path_16521"
          data-name="Path 16521"
          d="M321.2,41.008a11.4,11.4,0,0,0,11.671,11.129H373.78L321.2,2Z"
          transform="translate(-134.384)"
          fill="#52afa8"
        />
        <g
          id="Group_6668"
          data-name="Group 6668"
          transform="translate(112.104 2)"
        >
          <path
            id="Path_16522"
            data-name="Path 16522"
            d="M190.1,2h23.141V112.829H190.1Z"
            transform="translate(-181.904 -2)"
            fill="#445c6c"
          />
          <g
            id="Group_6666"
            data-name="Group 6666"
            transform="translate(11.284 0)"
          >
            <path
              id="Path_16523"
              data-name="Path 16523"
              d="M217.754,276.2s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V276.2Z"
              transform="translate(-206.485 -171.337)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16524"
              data-name="Path 16524"
              d="M203.5,265.766s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -161.209)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16525"
              data-name="Path 16525"
              d="M217.754,244s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V244Z"
              transform="translate(-206.485 -151.451)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16526"
              data-name="Path 16526"
              d="M203.5,233.566s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -141.323)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16527"
              data-name="Path 16527"
              d="M217.754,211.8s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V211.8Z"
              transform="translate(-206.485 -131.566)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16528"
              data-name="Path 16528"
              d="M203.5,201.366s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -121.438)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16529"
              data-name="Path 16529"
              d="M217.754,179.5s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V179.5Z"
              transform="translate(-206.485 -111.618)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16530"
              data-name="Path 16530"
              d="M203.5,169.066s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -101.49)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16531"
              data-name="Path 16531"
              d="M217.754,147.3s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V147.3Z"
              transform="translate(-206.485 -91.733)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16532"
              data-name="Path 16532"
              d="M203.5,136.866s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -81.605)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16533"
              data-name="Path 16533"
              d="M217.754,115.1s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V115.1Z"
              transform="translate(-206.485 -71.847)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16534"
              data-name="Path 16534"
              d="M203.5,104.666s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -61.719)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16535"
              data-name="Path 16535"
              d="M217.754,82.9s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V82.9Z"
              transform="translate(-206.485 -51.961)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16536"
              data-name="Path 16536"
              d="M203.5,72.466s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -41.833)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16537"
              data-name="Path 16537"
              d="M217.754,50.6s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V50.6Z"
              transform="translate(-206.485 -32.014)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16538"
              data-name="Path 16538"
              d="M203.5,40.166s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109-1.043,0-1.524-1.3-1.524-1.3h-5.7v5.966Z"
              transform="translate(-197.8 -21.886)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16539"
              data-name="Path 16539"
              d="M217.754,18.4s-.481,1.3-1.524,1.3c-.922,0-1.644-1.109-2.447-1.109-.682,0-1.484.841-1.484,2.792s.762,2.792,1.484,2.792c.8,0,1.564-1.109,2.447-1.109,1.043,0,1.524,1.3,1.524,1.3h5.7V18.4Z"
              transform="translate(-206.485 -12.128)"
              fill="#dbdfe0"
            />
            <path
              id="Path_16540"
              data-name="Path 16540"
              d="M203.5,7.966s.481-1.3,1.524-1.3c.922,0,1.644,1.109,2.447,1.109.682,0,1.484-.841,1.484-2.792s-.762-2.792-1.484-2.792c-.8,0-1.564,1.109-2.447,1.109C203.976,3.3,203.5,2,203.5,2h-5.7V7.966Z"
              transform="translate(-197.8 -2)"
              fill="#dbdfe0"
            />
          </g>
          <g
            id="Group_6667"
            data-name="Group 6667"
            transform="translate(0 108.419)"
          >
            <path
              id="Path_16541"
              data-name="Path 16541"
              d="M207.98,320.416l-5.7-16.674V288.9a3.5,3.5,0,0,0-3.569-3.4h-18.73a3.5,3.5,0,0,0-3.569,3.4v14.838l-5.735,16.712a18.053,18.053,0,0,0-.963,7.381c.722,9.255,8.663,16.712,18.369,17.248,11.43.65,20.9-7.955,20.9-18.7a16.4,16.4,0,0,0-1-5.966ZM189.371,338.7c-7.139,0-12.914-5.507-12.914-12.314s5.775-12.314,12.914-12.314,12.914,5.507,12.914,12.314S196.51,338.7,189.371,338.7Z"
              transform="translate(-169.664 -285.5)"
              fill="#fbd984"
            />
            <path
              id="Path_16542"
              data-name="Path 16542"
              d="M213.41,285.6a3.514,3.514,0,0,0-3.61,3.442v11.129a3.614,3.614,0,0,0,7.219,0V289.042A3.539,3.539,0,0,0,213.41,285.6Z"
              transform="translate(-193.703 -285.562)"
              fill="#e39a61"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgZip);
